import React, { useEffect, useState } from 'react';
import css from './JSONEditor.module.css';

const formatJSON = (jsonString: string) => {
  try {
    const parsedJSON = JSON.parse(jsonString);
    return JSON.stringify(parsedJSON, null, 2);
  } catch (error) {
    return jsonString;
  }
};

export const JSONEditor = ({
  defaultValue,
  onBlur,
}: {
  defaultValue?: Record<any, any> | string;
  onBlur?: (v?: Record<any, any> | Error) => void;
}) => {
  useEffect(() => {
    if (defaultValue) {
      setValue(formatJSON(JSON.stringify(defaultValue)));
    }
  }, [defaultValue]);

  const [value, setValue] = useState(
    formatJSON(JSON.stringify(defaultValue || {})),
  );
  const [error, setError] = useState('');

  const handleBlur = () => {
    const formatted = formatJSON(value);
    setValue(formatted);

    onBlur?.(JSON.parse(value));
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = event.target.value;
    setValue(inputValue);

    try {
      JSON.parse(inputValue);
      setError('');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className={css.container}>
      <textarea value={value} onChange={handleChange} onBlur={handleBlur} />

      {error && <p className={css.error}>{error}</p>}
    </div>
  );
};
